import { Cropper, ReactCropperElement } from "react-cropper";
import { useAppDispatch } from "../../store/hooks";
import { resetModals } from "../../store/slices/modalsSlice";
import ModalWrapper from "../Modals/ModalWrapper";
import useCheckIsMobile from "../lesson/lessonRefactor/utils/useCheckIsMobile";
import { Button } from "../ui/button";
import "/node_modules/cropperjs/dist/cropper.min.css";

const ImageUploaderPopup = ({
  cropperRef,
  image,
  getCropData,
}: {
  cropperRef: React.RefObject<ReactCropperElement>;
  image: string;
  getCropData: () => void;
}) => {
  const { isMobile } = useCheckIsMobile();
  const dispatch = useAppDispatch();

  return (
    <ModalWrapper>
      <div className="mw-[90%] p-2 pb-4 bg-white text-center rounded-lg flex flex-col justify-center gap-2">
        <Cropper
          ref={cropperRef}
          style={{
            height: isMobile ? undefined : 400,
            width: isMobile ? undefined : 400,
            margin: "1rem",
          }}
          zoomTo={0.5}
          initialAspectRatio={1}
          //   preview=".img-preview"
          src={image}
          viewMode={1}
          //   minCropBoxHeight={300}
          //   minCropBoxWidth={300}
          background={false}
          responsive={true}
          autoCropArea={1}
          checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
          guides={true}
        />
        <Button
          className="w-3/4 mx-auto mb-1"
          onClick={() => {
            console.log("upload image - step 1");
            getCropData();
          }}
        >
          إتمام قص الصورة
        </Button>
        <Button
          className="w-3/4 mx-auto bg-red-500 hover:bg-red-600"
          onClick={() => {
            dispatch(resetModals());
          }}
        >
          إلغاء
        </Button>
      </div>
    </ModalWrapper>
  );
};

export default ImageUploaderPopup;
